import React from 'react';
import { CustomSwitch } from '../../../atoms/Buttons/Switchs/CustomSwitch';
import { IconLabel } from '../../../atoms/Texts/IconLabel';

interface DisplaySwitchProps {
  onClick: (value: boolean) => void;
  defaultValue?: boolean;
}

export const DisplaySwitch = ({
  onClick,
  defaultValue = true
}: DisplaySwitchProps) => {
  return (
    <div>
      <IconLabel icon={'Landscape'} label={'Affichage'} />
      <CustomSwitch
        choiceOne={'Mosaique'}
        choiceTwo={'Liste'}
        onClick={onClick}
        defaultValue={defaultValue}
      />
    </div>
  );
};
